/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetAllAvailableVisualGuidesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllAvailableVisualGuidesQuery = {
  getAllAvailableVisualGuides: Array<{
    visualGuideId: string | null;
    name: string | null;
    deleted: boolean | null;
    container: string | null;
    steps: Array<{
      visualGuideStepId: string | null;
      resumeOnActions: Array<string | null> | null;
      forceWaitingForOtherGuides: boolean | null;
      pauseOnActions: Array<string | null> | null;
      waitForOtherGuides: boolean | null;
      waitForType: string | null;
      target: string | null;
      action: string | null;
      actions: Array<string> | null;
      isSubNav: boolean | null;
      openMainMenu: boolean | null;
      manualAck: boolean | null;
      isEnd: boolean | null;
      goToNextStepWhenOtherGuidesLoaded: boolean | null;
      message: string | null;
      enableClick: boolean | null;
      waitForMenuSelect: boolean | null;
    } | null> | null;
  } | null> | null;
};

export type VisualGuideStateFragment = {
  finished: boolean | null;
  finishedAt: number | null;
  lastStep: string | null;
  started: boolean | null;
  startedAt: number | null;
  visualGuideId: string | null;
};

export type UpdateVisualGuideStateMutationVariables = Exact<{
  visualGuideId: string;
  update?: Types.VisualGuideUserStateUpdate | null | undefined;
}>;

export type UpdateVisualGuideStateMutation = {
  updateVisualGuideState: {
    finished: boolean | null;
    finishedAt: number | null;
    lastStep: string | null;
    started: boolean | null;
    startedAt: number | null;
    visualGuideId: string | null;
  } | null;
};

export type GetMineVisualGuidesStateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMineVisualGuidesStateQuery = {
  getAllMineVisualGuideStates: Array<{
    finished: boolean | null;
    finishedAt: number | null;
    lastStep: string | null;
    started: boolean | null;
    startedAt: number | null;
    visualGuideId: string | null;
  } | null> | null;
};

export const VisualGuideStateFragmentDoc = gql`
  fragment VisualGuideState on UserVisualGuideState {
    finished
    finishedAt
    lastStep
    started
    startedAt
    visualGuideId
  }
`;
export const GetAllAvailableVisualGuidesDocument = gql`
  query getAllAvailableVisualGuides {
    getAllAvailableVisualGuides {
      visualGuideId
      name
      deleted
      steps {
        visualGuideStepId
        resumeOnActions
        forceWaitingForOtherGuides
        pauseOnActions
        waitForOtherGuides
        waitForType
        target
        action
        actions
        isSubNav
        openMainMenu
        manualAck
        isEnd
        goToNextStepWhenOtherGuidesLoaded
        message
        enableClick
        waitForMenuSelect
      }
      container
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllAvailableVisualGuidesGQL extends Apollo.Query<
  GetAllAvailableVisualGuidesQuery,
  GetAllAvailableVisualGuidesQueryVariables
> {
  document = GetAllAvailableVisualGuidesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateVisualGuideStateDocument = gql`
  mutation updateVisualGuideState(
    $visualGuideId: ID!
    $update: VisualGuideUserStateUpdate
  ) {
    updateVisualGuideState(visualGuideId: $visualGuideId, update: $update) {
      ...VisualGuideState
    }
  }
  ${VisualGuideStateFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateVisualGuideStateGQL extends Apollo.Mutation<
  UpdateVisualGuideStateMutation,
  UpdateVisualGuideStateMutationVariables
> {
  document = UpdateVisualGuideStateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMineVisualGuidesStateDocument = gql`
  query getMineVisualGuidesState {
    getAllMineVisualGuideStates {
      ...VisualGuideState
    }
  }
  ${VisualGuideStateFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetMineVisualGuidesStateGQL extends Apollo.Query<
  GetMineVisualGuidesStateQuery,
  GetMineVisualGuidesStateQueryVariables
> {
  document = GetMineVisualGuidesStateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
